import styles from './aboutUs.module.css'

const AboutUs = () =>
{
	return (
		<>
			<div className={styles.container}>
				<div className={styles.info}>
					<h1 className={styles.header}>About Us</h1>
					<h3 className={styles.header}>Our Story</h3>
					<p className={styles.description}>Welcome to Saurashtra Ice-Cream, your number one source for
						sweets. We're dedicated to giving you
						the very best varieties of Ice-Cream, with a focus on Customer service, Low prices and 100%
						organic products. Founded in 1999 by Niteshkumar, Saurashtra Ice-Cream has come a long way from
						its
						beginnings.When Saurashtra Ice-Cream first started our passion for high quality products at
						lower price drove us to do intense research and gave us the impetus to turn hard work and
						inspiration into to a booming store. We now serve customers all over Gujarat, and are thrilled
						to be a part of the eco-friendly wing of the food industry.
					</p>
					<br/>
					<p className={styles.description}>
						We hope you enjoy our products as much as we enjoy offering them to you. If you have any
						questions or comments, please don't hesitate to contact us
					</p>
				</div>
			</div>


		</>
	)
}

export default AboutUs